export default __webpack_public_path__ + "744100ce55619bee2dffe334c83c2ada.png";